import React, { Component } from 'react';
import LoadingButton from '../../../shared/ui/LoadingButton';
import defaultPropertiesUpdateFn from '../../models/form/defaultPropertiesUpdateFn';
import tagForOptions from '../../models/form/options/tag-for';
import selectValidationFn from '../../models/form/validation/select';
import textValidationFn from '../../models/form/validation/text';
import ValidatingSelect from '../../../shared/components/form/ValidatingSelect';
import ValidatingTextInput from '../../../shared/components/form/ValidatingTextInput';

class TagForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTouched: false,
      properties: {
        for: {
          isValid: !!props.initialValues,
          name: 'for',
          value: props.initialValues ? props.initialValues.for : '',
        },
        name: {
          isValid: !!props.initialValues,
          name: 'name',
          value: props.initialValues ? props.initialValues.name : '',
        },
      },
      tagForOptions,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // ----------------------
  // Computed
  // ----------------------

  get isFormValid() {
    return (
      this.state.isTouched &&
      !Object.keys(this.state.properties).find((key) => {
        return !this.state.properties[key].isValid;
      })
    );
  }

  // ----------------------
  // Methods
  // ----------------------

  handleChange(valueObject) {
    const callback = () => {
      if (!this.state.isTouched) {
        this.setState({ isTouched: true });
      }
    };
    this.setState(
      defaultPropertiesUpdateFn(valueObject.name, valueObject),
      callback,
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    const properties = {
      for: this.state.properties.for.value,
      name: this.state.properties.name.value.trim(),
    };
    this.props.onSave(properties);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="app-content">
        <form noValidate onSubmit={this.handleSubmit}>
          <ValidatingTextInput
            initialValue={this.props.initialValues ? this.props.initialValues.name : ''}
            label="Name"
            onChange={this.handleChange}
            name="name"
            required
            validationFn={textValidationFn('Name', true)}
            value={this.state.properties.name.value}
          />
          <ValidatingSelect
            initialValue={this.props.initialValues ? this.props.initialValues.for : ''}
            label="For"
            onChange={this.handleChange}
            name="for"
            options={this.state.tagForOptions}
            required
            validationFn={selectValidationFn('For', true)}
            value={this.state.properties.for.value}
          />
          <div className="text-right">
            <LoadingButton
              disabled={!this.isFormValid}
              isLoading={this.props.isLoading}
              primary
              text="Submit"
            />
          </div>
        </form>
      </div>
    );
  }
}

export default TagForm;
